import * as PaymentOverlayButton from './payment-overlay-button';

export const PaymentCompleteLayout = {
  ...PaymentOverlayButton,
};
